import clsx from 'clsx';

type Props = {
  label: string;
  tone: 'main' | 'shopPay' | 'black';
};

export default function Tooltip({label, tone}: Props) {
  return (
    <div
      className={clsx(
        'relative bg-soldOut top-[10px]',
        tone === 'shopPay' && 'text-shopPay',
        tone === 'main' && 'text-main',
        tone === 'black' && 'text-black',
      )}
    >
      {label}
    </div>
  );
}
